export default "__VITE_ASSET__o6A66QpM__"